import { render } from "./AppLogo.vue?vue&type=template&id=1314060a&scoped=true"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"

import "./AppLogo.vue?vue&type=style&index=0&id=1314060a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1314060a"]])

export default __exports__